export interface ICheckPublishTermSchema {
  // Тип периода публикации
  type?: string;
  // Применяемые услуги
  services: EServiceType[];
  // Количество дней публикации
  days: number;
  // Тариф
  tariffIdentificator?: ITariffIdentificatorSchema;
  // id рекомендованного пакета размещения (для услуги "Оптом дешевле")
  recommendedServicePackageId?: number;
  // ставка аукциона
  dynamicPrice?: number;
  /** Токен услуги **/
  token?: string | null;
}

export interface ITariffIdentificatorSchema {
  // Id тарифной сетки
  tariffId: number;
  // Тип тарифной сетки
  tariffGridType: string;
  // Количество дней публикации
  days: number;
  // Тип периода публикации
  periodType: string;
  // Список услуг в тарифе
  serviceTypes: string[];
  // ID пакета
  packageId: number;
}

export enum EServiceType {
  // Спрос
  demand = 'demand',
  // Бесплатная публикация
  free = 'free',
  // Платная публикация
  paid = 'paid',
  // Премиум публикация
  premium = 'premium',
  // Пакет заявок
  demandPackage = 'demandPackage',
  // Коллтрекинг
  calltracking = 'calltracking',
  // Аукцион
  auction = 'auction',
  // Топ
  top3 = 'top3',
  // Выделение цветом
  highlight = 'highlight',
  /** Подписка как VAS */
  servicePackage = 'servicePackage',
}
